import { useNavigate } from "react-router-dom";

import UserTopbar from "../../features/manageUsers/topbar";
import UserList from "../../features/manageUsers/userList";

const ManageUser = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Customer Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
          - Customer Management
        </p>
      </div>
      <div className="cards">
        <UserTopbar />
        <UserList />
      </div>
    </>
  );
};

export default ManageUser;
